export const footerTranslations = {
  penangGateway: {
    en: "Penang Gateway",
    zh: "槟城门户"
  },
  tagline: {
    en: "Your trusted companion for all things Penang. We help international visitors, students, and tourists navigate life in Penang with ease.",
    zh: "您在槟城所有事务的可靠伙伴。我们帮助国际游客、学生轻松玩转槟城生活。"
  },
  facebookSR: {
    en: "Facebook",
    zh: "脸书"
  },
  instagramSR: {
    en: "Instagram",
    zh: "照片墙"
  },
  twitterSR: {
    en: "Twitter",
    zh: "推特"
  },
  quickLinks: {
    en: "Quick Links",
    zh: "快速链接"
  },
  home: {
    en: "Home",
    zh: "首页"
  },
  studentServices: {
    en: "Student Services",
    zh: "学生服务"
  },
  immigration: {
    en: "Immigration",
    zh: "移民局"
  },
  accommodation: {
    en: "Accommodation",
    zh: "住宿"
  },
  faq: {
    en: "FAQ",
    zh: "常见问题"
  },
  services: {
    en: "Services",
    zh: "服务"
  },
  transportServices: {
    en: "Transport Services",
    zh: "交通服务"
  },
  lifeServices: {
    en: "Life Services",
    zh: "生活服务"
  },
  travelGuide: {
    en: "Travel Guide",
    zh: "旅游指南"
  },
  documentTranslation: {
    en: "Document Translation",
    zh: "文件翻译"
  },
  airportPickup: {
    en: "Airport Pickup",
    zh: "机场接送"
  },
  contactUs: {
    en: "Contact Us",
    zh: "联系我们"
  },
  address: {
    en: "George Town, Penang, Malaysia",
    zh: "马来西亚槟城乔治市"
  },
  allRightsReserved: {
    en: "Penang Gateway. All rights reserved.",
    zh: "槟城门户。版权所有。"
  }
};
